import { render, staticRenderFns } from "./IbListViewPlaceholderCard.vue?vue&type=template&id=419d41da&scoped=true"
import script from "./IbListViewPlaceholderCard.vue?vue&type=script&lang=js"
export * from "./IbListViewPlaceholderCard.vue?vue&type=script&lang=js"
import style0 from "./IbListViewPlaceholderCard.vue?vue&type=style&index=0&id=419d41da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d41da",
  null
  
)

export default component.exports